import { ReactNode } from "react";
import { motion } from "framer-motion";

interface ScrollRevealProps {
  children: ReactNode;
  delay?: number;
  direction?: "up" | "down" | "left" | "right";
  scale?: boolean;
  blur?: boolean;
  className?: string;
}

const ScrollReveal = ({ 
  children, 
  delay = 0,
  direction = "up",
  scale = true,
  blur = false,
  className
}: ScrollRevealProps) => {
  const getInitialPosition = () => {
    switch (direction) {
      case "up": return { y: 90, x: 0 };
      case "down": return { y: -90, x: 0 };
      case "left": return { x: 90, y: 0 };
      case "right": return { x: -90, y: 0 };
      default: return { y: 90, x: 0 };
    }
  };

  const variants = {
    hidden: {
      opacity: 0,
      ...getInitialPosition(),
      scale: scale ? 0.9 : 1,
      filter: blur ? "blur(12px)" : "blur(0px)",
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1,
      filter: "blur(0px)",
    },
  };

  return (
    <motion.div
      className={className}
      style={{ willChange: "transform, opacity", backfaceVisibility: "hidden", transformPerspective: "1000px" }}
      initial="hidden"
      whileInView="visible"
      onViewportEnter={() => console.log("ScrollReveal enter", { direction, delay })}
      viewport={{ once: true, amount: 0.05 }}
      variants={variants}
      transition={{
        duration: 0.9,
        delay,
        ease: [0.16, 1, 0.3, 1],
        type: "spring",
        stiffness: 140,
        damping: 18,
        mass: 0.6,
      }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
